<template>
  <div>
    <HeaderPage href="/products" />
    <div class="container_wrap">
      <div class="neiBanner">
        <div class="textBanner wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
          <dl>国正安全技术</dl>
          <dt>正念 / 正心 / 正言 / 正行</dt>
        </div>
      </div>
      <div class="indexFour service">
        <div class="wrap">
          <div class="ntitle wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <h3>PROFESSIONAL SERVICE</h3>
            <h2>服务项目</h2>
          </div>
          <div class="box wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
            <ul class="flex">
              <li>
                <div class="item">
                  <i><img src="@/assets/images/dIbPzMbI.png" alt=""></i>
                  <h3>安全</h3>
                  <div class="text">
                    <router-link :to="getUrl(item)" v-for="item in filteredItems(1)" :key="item.id">
                      <p>{{ item.name }}</p>
                    </router-link>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <i><img src="@/assets/images/wfjAG8Cl.png" alt=""></i>
                  <h3>职业卫生</h3>
                  <div class="text">
                    <router-link :to="getUrl(item)" v-for="item in filteredItems(2)" :key="item.id">
                      <p>{{item.name}}</p>
                    </router-link>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <i><img src="@/assets/images/A2ryKxbc.png" alt=""></i>
                  <h3>环境</h3>
                  <div class="text">
                    <router-link :to="getUrl(item)" v-for="item in filteredItems(2)" :key="item.id">
                      <p>{{item.name}}</p>
                    </router-link>

                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <FooterPage />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import axios from 'axios';

let intervalId


const productList = ref([])

const stopAutoScroll = () => {
  clearInterval(intervalId)
}

const filteredItems = (type) => {
  return productList.value.filter(item => item.type === type);
}
const getUrl = (item) => {
  return `/products/detail?id=${item.id}`;
}

onMounted(async () => {

  try {
    const res = await axios.get('/mock/productList.json'); // 本地Mock文件路径
    if (res.data.code === 200) {
      productList.value = res.data.data
    }
  } catch (err) {
    console.error('获取失败：', err);
  }



  // ✅ 滚动动画逻辑
  const elements = document.querySelectorAll('.wow')
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target
        const animateName = el.dataset.animate || 'fadeInUp'
        if (entry.isIntersecting) {
          el.classList.add('animated', animateName)
          // ✅ 添加后立即取消观察，避免重复触发
          observer.unobserve(el)
        }
      })
    },
    { threshold: 0.2 }
  )
  elements.forEach((el) => observer.observe(el))
  onUnmounted(() => {
    elements.forEach((el) => observer.unobserve(el))
    stopAutoScroll()
  })
})

</script>

<style scoped>
.neiBanner {
  height: 640px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: url('@/assets/images/bg/Kw233a.jpg');
}

.neiBanner .textBanner {
  color: #fff;
  text-align: center;
  font-weight: bold;
}

.neiBanner .textBanner dl {
  font-size: 72px;
}

.neiBanner .textBanner dt {
  font-size: 30px;
  font-weight: 500;
}

.service.indexFour {
  padding: 80px 0 150px;
  background: none;
}

.wrap {
  width: 1680px;
  margin: 0 auto;
}

.flex {
  display: flex;
  width: 100%;
}

.ntitle {
  text-align: center;
  margin-bottom: 50px;
}

.ntitle h3 {
  font-size: 38px;
  line-height: 1;
  color: #003366;
  font-weight: 500;
  border-bottom: #003366 solid 1px;
  display: inline-block;
  padding: 0 0 15px;
  margin-bottom: 15px;
}

.ntitle h2 {
  font-size: 36px;
  line-height: 1;
  color: #333;
  font-weight: 500;
}

.indexFour .box {
  padding: 20px 30px 0;
}

.indexFour .box ul li {
  width: 33.33%;
  padding: 0 30px;
  list-style: none;
}

.indexFour .item {
  height: 100%;
  padding: 0 45px 45px;
  background: #f5f5f5;
  transition: all 0.4s;
}

.indexFour .item i {
  width: 110px;
  height: 110px;
  line-height: 110px;
  text-align: center;
  background: #00437c;
  display: block;
}

.indexFour .item h3 {
  font-size: 36px;
  border-bottom: #a88333 solid 2px;
  padding: 20px;
  margin-bottom: 30px;
}

.indexFour .item .text {
  font-size: 18px;
}

.indexFour .item .text p {
  margin-bottom: 13px;
}

.indexFour .item .text p::before {
  content: "▪";
  font-size: 14px;
  margin-right: 15px;
}
</style>